import {
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';
import { InputLabelContainer } from './styled';

const InputLabel = () => (
  <InputLabelContainer>
    <TextCustom
      appearance={TextAppearance.headline200}
      style={{
        fontWeight: TextWeight.bold,
        fontSize: TextSize.TextSize20,
        lineHeight: TextLineHeight.TextLineHeight24,
      }}
    >
      VIN (Vehicle Identification Number)
    </TextCustom>
  </InputLabelContainer>
);

export default InputLabel;
